var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:edit-name"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5052 11.6237C18.002 11.6237 20.026 9.59965 20.026 7.10286C20.026 4.60608 18.002 2.58203 15.5052 2.58203C13.0084 2.58203 10.9844 4.60608 10.9844 7.10286C10.9844 9.59965 13.0084 11.6237 15.5052 11.6237Z",
    stroke: "#A5A5A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.58594 26.4779C2.58594 20.7706 7.79071 16.1445 14.2109 16.1445M20.0234 27.1237L26.4818 20.6654L23.8984 18.082L17.4401 24.5404V27.1237H20.0234Z",
    stroke: "#A5A5A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c708b7d21885582cda83816136f224cc.svg";
export { ForwardRef as ReactComponent };